import { render, staticRenderFns } from "./PromoCodesAdd.vue?vue&type=template&id=90467b34&"
import script from "./PromoCodesAdd.vue?vue&type=script&lang=js&"
export * from "./PromoCodesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports